import { createSelector } from 'reselect'
import { RootState } from 'redux/root-reducer'

const selectCaptionInput = (state: RootState) => state.captions

export const selectCaptions = createSelector(
    [selectCaptionInput],
    (captions) => captions.captionInputs
)
